export default "__VITE_ASSET__zJEQLSBh__"